import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  EventEmitter,
  Output,
} from "@angular/core";

@Component({
  selector: "image-upload-modal",
  templateUrl: "./image-upload-modal.component.html",
  styleUrls: [
    "./image-upload-modal.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class ImageUploadModal implements OnInit {
  // variables to pass on to modal form
  @Input() targetObject: any;
  @Input() targetType: string;
  @Output() emitImage = new EventEmitter<string>();

  // modal inputs
  @Input() dialogClass: string;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  public visible = false;
  public visibleAnimate = false;

  constructor() {}

  ngOnInit() {}

  public saveImage(url) {
    this.emitImage.emit(url);
    this.hide();
  }

  public show(): void {
    this.visible = true;
    setTimeout(() => (this.visibleAnimate = true), 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => (this.visible = false), 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains("modal")) {
      this.hide();
    }
  }
}
